import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL, WEIGHT_LOSS_EXAM, IV_THERAPY_EXAM } from '../constants';

function ExamThankYouPage() {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const requestId = queryParams.get('requestId');
  const type = queryParams.get('type');
  const status = queryParams.get('status');
  const sessionId = queryParams.get('session_id');

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [meetingUrl, setMeetingUrl] = useState('');

  useEffect(() => {
    const updatePaymentStatus = async () => {
      try {
        if (type === WEIGHT_LOSS_EXAM) {
          await axios.patch(
            `${BASE_URL}/request/weightLoss/paymentStatus/${requestId}`,
            {
              firstDeposit: true,
              sessionId,
            }
          );
        } else if (type === IV_THERAPY_EXAM) {
          await axios.patch(
            `${BASE_URL}/request/ivTherapy/paymentStatus/${requestId}`,
            {
              firstDeposit: true,
              sessionId,
            }
          );
        }

        const getMeetingLink = async () => {
          try {
            let response;

            if (type === WEIGHT_LOSS_EXAM) {
              response = await axios.get(
                `${BASE_URL}/request/weightLoss/exam/link?requestId=${requestId}&firstDepositRequired=true`
              );
            } else if (type === IV_THERAPY_EXAM) {
              response = await axios.get(
                `${BASE_URL}/request/ivTherapy/exam/link?requestId=${requestId}&firstDepositRequired=true`
              );
            }

            setMeetingUrl(response.data.meetingLink);
          } catch (error) {
            console.error('Error fetching the meeting link:', error);
            setError(
              error.response?.data?.error ||
                'Failed to process your request. Please try again later.'
            );
          } finally {
            setLoading(false);
          }
        };

        getMeetingLink();
      } catch (error) {
        console.error('Error updating payment status:', error);
        setError(
          error.response?.data?.error ||
            'Failed to update payment status. Please try again later.'
        );
        setLoading(false);
      }
    };

    if (status && status === 'success' && requestId && sessionId) {
      updatePaymentStatus();
    } else {
      if (status && status === 'error') {
        setError('Your payment failed due to some reason. Please try again.');
        setLoading(false);
        return;
      }
      console.log('Payment');
      setError('Missing required parameters: requestId, sessionId, or status.');
      setLoading(false);
    }
  }, [requestId, sessionId, status, type]);

  if (loading) {
    return (
      <div className='flex items-center justify-center h-screen bg-gray-100 text-gray-700 font-sans'>
        <div className='flex flex-col items-center'>
          <div className='loader'></div>
          <p className='mt-8 text-lg'>Processing your request...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='flex items-center justify-center h-screen bg-gray-100 text-gray-700 font-sans'>
        <div className='text-center p-6 bg-white rounded-lg shadow-lg'>
          <h2 className='text-2xl font-semibold text-red-600'>Error</h2>
          <p className='mt-4'>{error}</p>
          <button
            onClick={() => {
              setError(null);
              window.location.reload();
            }}
            className='mt-6 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700'
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className='min-h-screen flex flex-col bg-gray-100 text-gray-500 font-sans'>
      <div className='w-full max-w-screen-xl mx-auto'>
        <div className='text-center'>
          <h1 className='text-5xl text-primaryBlue mt-20'>
            Thank You For Choosing Us!
          </h1>
          <p className='text-left text-md mt-10'>Hi,</p>
          <p className='text-left text-md mt-6'>
            Click the button below, to be connected to a medical provider for
            your Telehealth exam so that your prescription can be processed.
          </p>
          <div className='text-left'>
            <button
              onClick={() => (window.location.href = meetingUrl)}
              className='mt-10 px-6 py-3 bg-primaryBlue text-white text-md rounded-3xl hover:bg-opacity-90'
            >
              Connect With A Provider Now
            </button>
          </div>
        </div>
      </div>
      <div className='w-full max-w-screen-xl mx-auto text-left my-10'>
        <h2 className='text-xl font-semibold text-primaryBlue'>Instructions</h2>
        <ul className='list-disc text-md ml-6 mt-4 space-y-2'>
          <li>Accept Permissions for Microphone & video</li>
          <li>Disconnect from any Bluetooth devices</li>
          <li>Stable internet connection</li>
          <li>Noise-Free Environment</li>
          <li>
            If video/audio drops, you will receive a phone call to complete the
            evaluation
          </li>
        </ul>
      </div>
    </div>
  );
}

export default ExamThankYouPage;
